import { redirectIfUnauthorized } from '@/app/shared/utils/router-guards/auth';

const BASE_PATH = '/users';

const UsersRoutes = [
    {
        name: 'UsersList',
        path: `${BASE_PATH}/list`,
        component: () => import('@/app/modules/users/UsersList/UsersList.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.settings.userManagement.list
        ),
    },
    {
        name: 'UsersUserEvents',
        path: `${BASE_PATH}/:userId/main-events/:mainEventId/events`,
        component: () => import('@/app/modules/users/UserMainEventEvents/UserMainEventEvents.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.settings.userManagement.list
        ),
    },
    {
        name: 'UsersUserMainEvents',
        path: `${BASE_PATH}/:userId/main-events`,
        component: () => import('@/app/modules/users/UserMainEvents/UserMainEvents.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.settings.userManagement.list
        ),
    },
    {
        name: 'UsersUserMainEventVenues',
        path: `${BASE_PATH}/:userId/main-events/:mainEventId/venues`,
        component: () => import('@/app/modules/users/UserMainEventVenues/UserMainEventVenues.vue'),
        props: true,
        beforeEnter: redirectIfUnauthorized(
            (permissions) => permissions.settings.userManagement.list
        ),
    },
    {
        name: 'UserProfile',
        path: `/user/profile`,
        component: () => import('@/app/core/components/AppHeader/components/UserProfile.vue'),
        props: true,
    },
];

export default UsersRoutes;
